import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { BcFooterBehavior } from '@bancolombia/design-system-behaviors';
import * as i1 from '@bancolombia/design-system-web/bc-helpers';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@bancolombia/design-system-web/bc-icon';
import { BcIconModule } from '@bancolombia/design-system-web/bc-icon';
import * as i4 from '@bancolombia/design-system-web/bc-link';
import { BcLinkModule } from '@bancolombia/design-system-web/bc-link';
import * as i5 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i6 from '@bancolombia/design-system-web/bc-logo';
import { BcLogoModule, environment } from '@bancolombia/design-system-web/bc-logo';
import * as i7 from '@bancolombia/design-system-web/bc-stroke';
import { BcStrokeModule, environment as environment$1 } from '@bancolombia/design-system-web/bc-stroke';
import { BcAccordionModule } from '@bancolombia/design-system-web/bc-accordion';

/**
 * Importa el componente footer con los diseños de Bancolombia S.A.
 * se utiliza para los pie de página.
 *
 * @export
 * @class BcfooterComponent
 * @implements {AfterViewInit}
 */
class BcFooterComponent {
    constructor(bcHelperService) {
        this.bcHelperService = bcHelperService;
        /**
         * Id del elemento.
         *
         * @type {string}
         * @memberof BcfooterComponent
         */
        this.componentId = this.bcHelperService.getId(this);
        /**
         * Links para enlaces de interés
         *
         * @type {ITopLinks}
         * @memberof BcfooterComponent
         */
        this.topLinks = {
            links: [
                {
                    text: '',
                    method: '',
                    link: '',
                    isSelf: false
                }
            ]
        };
        /**
         * Objeto para mostrar las columnas con títulos y enlaces de la parte superior del footer.
         *
         * @type {ITopTextContent[]}
         * @memberof BcfooterComponent
         */
        this.topTextContent = [
            {
                title: { text: '', link: '', onlyStyleText: false, isSelf: false },
                texts: [{ text: '', link: '', isSelf: false }]
            }
        ];
        /**
         * Array de textos que se muestra en la parte inferior izquierda del footer.
         *
         * @type {Array<string>}
         * @memberof BcfooterComponent
         */
        this.bottomTextLeftContent = [];
        /**
         * Array de textos que se muestra en la parte inferior derecha del footer. Luego de redes sociales.
         *
         * @type {Array<string>}
         * @memberof BcfooterComponent
         */
        this.bottomTextRighContent = [];
        /**
         * Array de objetos para las redes sociales. En name pueden ir facebook,twitter,linkedin,instagram,youtube.
         *
         * @type {ISocialNetBottomRight[]}
         * @memberof BcfooterComponent
         */
        this.socialNetBottomRight = [{ name: '', link: '', isSelf: false, ariaLabel: '' }];
        /**
         * Boolean que por defecto esta false y muestra el logo de Bancolombia en la parte inferior.
         *
         * @type {boolean}
         * @memberof BcfooterComponent
         */
        this.isBancoLogoBottom = false;
        /**
         * Boolean que por defecto esta false y muestra el isotipo Bancolombia en la parte inferior.
         *
         * @type {boolean}
         * @memberof BcfooterComponent
         */
        this.isBancoIsotipoBottom = false;
        /**
         * Boolean que por defecto esta true y muestra el logo vigilado en la parte inferior.
         *
         * @type {boolean}
         * @memberof BcfooterComponent
         */
        this.isVigilaLogoBottom = true;
        /**
         * Esta propiedad está siendo deprecada.
         *
         * @memberof BcfooterComponent
         * @deprecated Color de fondo es transparente de acuerdo a documentación en Figma.
         */
        this.bgWhite = false;
        /**
         * Esta propiedad está siendo deprecada.
         *
         * @memberof BcfooterComponent
         * @deprecated Color de fondo es transparente de acuerdo a documentación en Figma.
         */
        this.bgGray = false;
        /**
         * Esta propiedad está siendo deprecada.
         *
         * @memberof BcfooterComponent
         * @deprecated Propiedad no utilizada
         */
        this.icon = 'left';
        /**
         * Define el isotipo a usar en el footer.
         *
         * @type {string}
         * @memberof BcfooterComponent
         */
        this.isotipo = 'isotipo-bancolombia';
        /**
         * Define el logo a usar en el footer.
         *
         * @type {string}
         * @memberof BcfooterComponent
         */
        this.logo = 'bancolombia-horizontal-no-spacing';
        /**
         * Indica si footer utiliza stroke. Valor default true.
         *
         * @type {boolean}
         * @memberof BcfooterComponent
         */
        this.useStroke = true;
        /**
        * Indica valor de atributo alt de stroke.
        *
        * @type {boolean}
        * @memberof BcfooterComponent
        */
        this.altStroke = 'logo';
        this.methodCallout = new EventEmitter();
        this.componentReady = false;
    }
    ngOnChanges(changes) {
        if (this.componentReady && changes.topTextContent) {
            setTimeout(() => {
                this.bcFooterBehavior.updateAccordion();
            });
        }
    }
    methodCall(method) {
        this.methodCallout.emit(method);
    }
    ngAfterViewInit() {
        this._initBehavior();
    }
    _initBehavior() {
        this.bcFooterBehavior = new BcFooterBehavior();
        this.bcFooterBehavior.setId(this.componentId);
        this.bcFooterBehavior.setUp();
        this.componentReady = true;
    }
    _isInternalLink(link, isSelf) {
        if (link && !link.startsWith('http') && isSelf) {
            return true;
        }
        return false;
    }
}
BcFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BcFooterComponent, deps: [{ token: i1.BcHelperService }], target: i0.ɵɵFactoryTarget.Component });
BcFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BcFooterComponent, selector: "bc-footer", inputs: { componentId: "componentId", topLinks: "topLinks", topTextContent: "topTextContent", bottomTextLeftContent: "bottomTextLeftContent", bottomTextRighContent: "bottomTextRighContent", socialNetBottomRight: "socialNetBottomRight", isBancoLogoBottom: "isBancoLogoBottom", isBancoIsotipoBottom: "isBancoIsotipoBottom", isVigilaLogoBottom: "isVigilaLogoBottom", bgWhite: "bgWhite", bgGray: "bgGray", icon: "icon", isotipo: "isotipo", logo: "logo", colorStroke: "colorStroke", useStroke: "useStroke", altStroke: "altStroke" }, outputs: { methodCallout: "methodCallout" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"bc-footer\" [id]=\"componentId\">\n  <div class=\"bc-container\">\n    <div class=\"bc-footer-top\" *ngIf=\"topTextContent[0].title.text\">\n      <div class=\"bc-footer-top-container\" *ngFor=\"let content of topTextContent; let i = index\">\n        <div class=\"bc-footer-top-container-t\">\n          <h6>\n            <ng-container>\n              {{ content.title.text }}\n            </ng-container>\n          </h6>\n        </div>\n        <div class=\"bc-footer-top-container-p\" *ngIf=\"content.texts\">\n          <ng-container *ngFor=\"let p of content.texts\">\n            <a\n              *ngIf=\"!_isInternalLink(p.link, p.isSelf)\"\n              bc-link\n              [href]=\"p.link\"\n              [attr.target]=\"p.isSelf ? null : '_blank'\"\n              [attr.rel]=\"p.isSelf ? null : 'noopener noreferrer'\"\n            >\n              {{ p.text }}\n            </a>\n            <a *ngIf=\"_isInternalLink(p.link, p.isSelf)\" bc-link [routerLink]=\"p.link\">\n              {{ p.text }}\n            </a>\n          </ng-container>\n        </div>\n      </div>\n    </div>\n    <div class=\"bc-footer-top-links\" *ngIf=\"topLinks.links[0].text\">\n      <div class=\"bc-footer-top-links-ca\" *ngFor=\"let content of topLinks.links; let i = index\">\n        <a\n          *ngIf=\"content.link != '' && content.link != null && !_isInternalLink(content.link, content.isSelf)\"\n          bc-link\n          [href]=\"content.link\"\n          [attr.target]=\"content.isSelf ? null : '_blank'\"\n          [attr.rel]=\"content.isSelf ? null : 'noopener noreferrer'\"\n        >\n          {{ content.text }}\n        </a>\n        <a\n          *ngIf=\"content.link != '' && content.link != null && _isInternalLink(content.link, content.isSelf)\"\n          bc-link\n          [routerLink]=\"content.link\"\n        >\n          {{ content.text }}\n        </a>\n\n        <a\n          bc-link\n          *ngIf=\"content.method != '' && content.method != null\"\n          class=\"bc-footer-top-links-ca-a\"\n          (click)=\"methodCall(content.method)\"\n        >\n          {{ content.text }}\n        </a>\n      </div>\n    </div>\n    <div class=\"bc-footer-divisor\"></div>\n    <div class=\"bc-footer-bottom\">\n      <div class=\"bc-footer-bottom-left\">\n        <div class=\"bc-footer-bottom-left-icon\" *ngIf=\"isBancoIsotipoBottom\">\n          <bc-logo size=\"32px\" alt=\"logo\" [name]=\"isotipo\"></bc-logo>\n        </div>\n        <div class=\"bc-footer-bottom-left-side\">\n          <div class=\"bc-footer-bottom-top-icon\" *ngIf=\"isBancoLogoBottom\">\n            <bc-logo size=\"150px\" alt=\"logo\" [name]=\"logo\"></bc-logo>\n          </div>\n          <p *ngFor=\"let text of bottomTextLeftContent\" [innerHTML]=\"text\"></p>\n          <div class=\"bc-footer-bottom-left-side-vigilant\" *ngIf=\"isVigilaLogoBottom\">\n            <bc-logo\n              alt=\"Vigilado Superintendencia Financiera de Colombia\"\n              [name]=\"'logo-vigilado'\"\n              [size]=\"'16px'\"\n              aria-hidden=\"false\"\n            ></bc-logo>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"bc-footer-bottom-right\">\n        <div class=\"bc-footer-bottom-right-network-icons\" *ngIf=\"socialNetBottomRight[0]?.name\">\n          <a\n            *ngFor=\"let social of socialNetBottomRight\"\n            href=\"{{ social.link }}\"\n            [attr.target]=\"social.isSelf ? null : '_blank'\"\n            [attr.aria-label]=\"social.ariaLabel || 'Ir a ' + social.name\"\n            [attr.rel]=\"social.isSelf ? null : 'noopener noreferrer'\"\n            bc-link\n          >\n            <bc-icon aria-hidden=\"true\">\n              {{ social.name }}\n            </bc-icon>\n          </a>\n        </div>\n        <div class=\"bc-footer-bottom-right-text\" *ngIf=\"bottomTextRighContent.length > 0\">\n          <p *ngFor=\"let text of bottomTextRighContent\">{{ text }}</p>\n        </div>\n      </div>\n    </div>\n    <bc-stroke\n      *ngIf=\"useStroke\"\n      class=\"bc-footer-stroke-colors\"\n      size=\"420px\"\n      [ariaHidden]=\"true\"\n      [alt]=\"altStroke\"\n      [name]=\"'14'\"\n    ></bc-stroke>    \n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.BcIconComponent, selector: "bc-icon", inputs: ["ariaLabel", "size", "width", "name", "class"] }, { kind: "directive", type: i4.BcLinkDirective, selector: "[bc-link]", inputs: ["typeLink", "sizeLink", "class"] }, { kind: "directive", type: i5.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: i6.BcLogoComponent, selector: "bc-logo", inputs: ["size", "alt", "name", "class"] }, { kind: "component", type: i7.BcStrokeComponent, selector: "bc-stroke", inputs: ["size", "alt", "name", "class"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BcFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bc-footer', template: "<div class=\"bc-footer\" [id]=\"componentId\">\n  <div class=\"bc-container\">\n    <div class=\"bc-footer-top\" *ngIf=\"topTextContent[0].title.text\">\n      <div class=\"bc-footer-top-container\" *ngFor=\"let content of topTextContent; let i = index\">\n        <div class=\"bc-footer-top-container-t\">\n          <h6>\n            <ng-container>\n              {{ content.title.text }}\n            </ng-container>\n          </h6>\n        </div>\n        <div class=\"bc-footer-top-container-p\" *ngIf=\"content.texts\">\n          <ng-container *ngFor=\"let p of content.texts\">\n            <a\n              *ngIf=\"!_isInternalLink(p.link, p.isSelf)\"\n              bc-link\n              [href]=\"p.link\"\n              [attr.target]=\"p.isSelf ? null : '_blank'\"\n              [attr.rel]=\"p.isSelf ? null : 'noopener noreferrer'\"\n            >\n              {{ p.text }}\n            </a>\n            <a *ngIf=\"_isInternalLink(p.link, p.isSelf)\" bc-link [routerLink]=\"p.link\">\n              {{ p.text }}\n            </a>\n          </ng-container>\n        </div>\n      </div>\n    </div>\n    <div class=\"bc-footer-top-links\" *ngIf=\"topLinks.links[0].text\">\n      <div class=\"bc-footer-top-links-ca\" *ngFor=\"let content of topLinks.links; let i = index\">\n        <a\n          *ngIf=\"content.link != '' && content.link != null && !_isInternalLink(content.link, content.isSelf)\"\n          bc-link\n          [href]=\"content.link\"\n          [attr.target]=\"content.isSelf ? null : '_blank'\"\n          [attr.rel]=\"content.isSelf ? null : 'noopener noreferrer'\"\n        >\n          {{ content.text }}\n        </a>\n        <a\n          *ngIf=\"content.link != '' && content.link != null && _isInternalLink(content.link, content.isSelf)\"\n          bc-link\n          [routerLink]=\"content.link\"\n        >\n          {{ content.text }}\n        </a>\n\n        <a\n          bc-link\n          *ngIf=\"content.method != '' && content.method != null\"\n          class=\"bc-footer-top-links-ca-a\"\n          (click)=\"methodCall(content.method)\"\n        >\n          {{ content.text }}\n        </a>\n      </div>\n    </div>\n    <div class=\"bc-footer-divisor\"></div>\n    <div class=\"bc-footer-bottom\">\n      <div class=\"bc-footer-bottom-left\">\n        <div class=\"bc-footer-bottom-left-icon\" *ngIf=\"isBancoIsotipoBottom\">\n          <bc-logo size=\"32px\" alt=\"logo\" [name]=\"isotipo\"></bc-logo>\n        </div>\n        <div class=\"bc-footer-bottom-left-side\">\n          <div class=\"bc-footer-bottom-top-icon\" *ngIf=\"isBancoLogoBottom\">\n            <bc-logo size=\"150px\" alt=\"logo\" [name]=\"logo\"></bc-logo>\n          </div>\n          <p *ngFor=\"let text of bottomTextLeftContent\" [innerHTML]=\"text\"></p>\n          <div class=\"bc-footer-bottom-left-side-vigilant\" *ngIf=\"isVigilaLogoBottom\">\n            <bc-logo\n              alt=\"Vigilado Superintendencia Financiera de Colombia\"\n              [name]=\"'logo-vigilado'\"\n              [size]=\"'16px'\"\n              aria-hidden=\"false\"\n            ></bc-logo>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"bc-footer-bottom-right\">\n        <div class=\"bc-footer-bottom-right-network-icons\" *ngIf=\"socialNetBottomRight[0]?.name\">\n          <a\n            *ngFor=\"let social of socialNetBottomRight\"\n            href=\"{{ social.link }}\"\n            [attr.target]=\"social.isSelf ? null : '_blank'\"\n            [attr.aria-label]=\"social.ariaLabel || 'Ir a ' + social.name\"\n            [attr.rel]=\"social.isSelf ? null : 'noopener noreferrer'\"\n            bc-link\n          >\n            <bc-icon aria-hidden=\"true\">\n              {{ social.name }}\n            </bc-icon>\n          </a>\n        </div>\n        <div class=\"bc-footer-bottom-right-text\" *ngIf=\"bottomTextRighContent.length > 0\">\n          <p *ngFor=\"let text of bottomTextRighContent\">{{ text }}</p>\n        </div>\n      </div>\n    </div>\n    <bc-stroke\n      *ngIf=\"useStroke\"\n      class=\"bc-footer-stroke-colors\"\n      size=\"420px\"\n      [ariaHidden]=\"true\"\n      [alt]=\"altStroke\"\n      [name]=\"'14'\"\n    ></bc-stroke>    \n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1.BcHelperService }]; }, propDecorators: { componentId: [{
                type: Input
            }], topLinks: [{
                type: Input
            }], topTextContent: [{
                type: Input
            }], bottomTextLeftContent: [{
                type: Input
            }], bottomTextRighContent: [{
                type: Input
            }], socialNetBottomRight: [{
                type: Input
            }], isBancoLogoBottom: [{
                type: Input
            }], isBancoIsotipoBottom: [{
                type: Input
            }], isVigilaLogoBottom: [{
                type: Input
            }], bgWhite: [{
                type: Input
            }], bgGray: [{
                type: Input
            }], icon: [{
                type: Input
            }], isotipo: [{
                type: Input
            }], logo: [{
                type: Input
            }], colorStroke: [{
                type: Input
            }], useStroke: [{
                type: Input
            }], altStroke: [{
                type: Input
            }], methodCallout: [{
                type: Output
            }] } });

/**
 * Importa el componente BcFooter con
 * los diseños de Bancolombia S.A.
 *
 * @componente <bc-footer></bc-footer>
 *
 * @param  [topTextContent] : [{
 *      title: { text: '' },
 *       texts: [ { text: '', link:'',(opcional) isSelf: false (opcional) },]
 *   }] (opcional) : Objeto para mostrar los textos de arriba del footer
 * @param  [bottomTextLeftContent](opcional): Array de textos que se muestra en la parte
 * inferior izquierda del footer
 * @param  [bottomTextRighContent](opcional): Array de textos que se muestra en la parte
 * inferior derecha del footer
 * @param  [socialNetBottomRight : [{ name:'', link:'', isSelf:false (opcional), ariaLabel: '' (opcional) }]]: Array de
 * objetos para las redes sociales. En name pueden ir facebook,twitter,linkedin,instagram,youtube
 * @param [isBancoLogoBottom](opcional): Boolean que por defecto esta false y muestra el icono
 * bancolombia en la parte inferior derecha
 * @param [isBancoIsotipoBottom](opcional): Boolean que por defecto esta false y muestra el icono
 * bancolombia en la parte inferior derecha
 * @param [isVigilaLogoBottom](opcional): Boolean que por defecto esta true y muestra el icono
 * vigilado en la parte inferior
 * @param [id](opcional): string : Indica el id del componente
 *
 *
 * @example
 *
 * <bc-footer [topTextContent]="[
 * {
 *    title: { text: 'Titulo columna 01' },
 *     texts: [
 * { text: 'Lorem ipsum' },
 * { text: 'Lorem ipsum' },
 *  { text: 'Lorem ipsum' },
 *  { text: 'Lorem ipsum' }, ]
 * },
 * {
 *    title: { text: 'Titulo columna 02' },
 *   texts: [ { text: 'Lorem ipsum' }, { text: 'Lorem ipsum' }, { text: 'Lorem ipsum' }, { text: 'Lorem ipsum' } ]
 * },
 * {
 *     title: { text: 'Titulo columna 03' },
 *     texts: [ { text: 'Lorem ipsum' }, { text: 'Lorem ipsum' }, { text: 'Lorem ipsum' }, { text: 'Lorem ipsum' } ]
 * },
 * {
 *     title: { text: 'Titulo columna 04' },
 *     texts: [ { text: 'Lorem ipsum' }, { text: 'Lorem ipsum' }, { text: 'Lorem ipsum' }, { text: 'Lorem ipsum' } ]
 * }]" [socialNetBottomRight]="[
 *     { name:'facebook', link:'/' },
 *     { name:'twitter', link:'/' },
 *     { name:'linkedin', link:'/' },
 *     { name:'instagram', link:'/' },
 *     { name:'youtube', link:'/' }
 * ]" [bottomTextRighContent]="['Dirección IP 190.144.71.250','Última visita Jueves 31 de Julio de 2019 10:06 a.m']"
 *     [bottomTextLeftContent]="['Copyright © 2020 Grupo Bancolombia. Sed egestas, ante et vulputate volutpat, eros',
 * 'pede semper est, vitae luctus metus libero eu augue. Morbi purus libero, faucibus ',
 * 'adipiscing, commodo quis, gravida id, est. Sed lectus. Praesent elementum hendrerit ',
 * 'tortor. Sed semper lorem at felis. Vestibulum volutpat, lacus a ultrices sagittis.']">
 * </bc-footer>
 *
 * @author: Bancolombia S.A
 */
class BcFooterModule {
}
BcFooterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BcFooterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BcFooterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: BcFooterModule, declarations: [BcFooterComponent], imports: [CommonModule,
        BcIconModule,
        BcAccordionModule,
        BcLinkModule,
        RouterModule, i6.BcLogoModule, i7.BcStrokeModule], exports: [BcFooterComponent] });
BcFooterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BcFooterModule, imports: [CommonModule,
        BcIconModule,
        BcAccordionModule,
        BcLinkModule,
        RouterModule,
        BcLogoModule.forRoot({ path: environment.url }),
        BcStrokeModule.forRoot({ path: environment$1.url })] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BcFooterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BcFooterComponent],
                    imports: [
                        CommonModule,
                        BcIconModule,
                        BcAccordionModule,
                        BcLinkModule,
                        RouterModule,
                        BcLogoModule.forRoot({ path: environment.url }),
                        BcStrokeModule.forRoot({ path: environment$1.url })
                    ],
                    exports: [BcFooterComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BcFooterComponent, BcFooterModule };
